(function () {
  'use strict';

  function calcTwoRowsHeight(gallery) {
    const grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return null;

    const items = Array.from(grid.querySelectorAll(':scope > .media-gallery__grid-item'));
    if (!items.length) return null;

    // Group items by their top position (= row)
    const rowMap = {};
    for (const item of items) {
      const top = Math.round(item.getBoundingClientRect().top);
      if (!rowMap[top]) rowMap[top] = [];
      rowMap[top].push(item);
    }

    const rowTops = Object.keys(rowMap).map(Number).sort((a, b) => a - b);
    if (rowTops.length < 2) return null;

    // Bottom of the second row
    const secondRowTop = rowTops[1];
    const secondRowBottom = Math.max(
      ...rowMap[secondRowTop].map(item => item.getBoundingClientRect().bottom)
    );

    const galleryTop = gallery.getBoundingClientRect().top;
    return Math.round(secondRowBottom - galleryTop);
  }

  function initGalleryShowMore(btn) {
    const galleryId = btn.getAttribute('aria-controls');
    const gallery = document.getElementById(galleryId);
    if (!gallery) return;

    const textEl = btn.querySelector('.show-more-text');

    // Set initial collapsed height
    const collapsedHeight = calcTwoRowsHeight(gallery);
    if (collapsedHeight) {
      gallery.style.maxHeight = collapsedHeight + 'px';
    }

    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        const h = calcTwoRowsHeight(gallery);
        if (h) gallery.style.maxHeight = h + 'px';
        btn.setAttribute('aria-expanded', 'false');
        textEl.textContent = btn.dataset.textMore || 'Pokaż więcej';
        gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        gallery.style.maxHeight = 'none';
        btn.setAttribute('aria-expanded', 'true');
        textEl.textContent = btn.dataset.textLess || 'Pokaż mniej';
      }
    });
  }

  document.querySelectorAll('.product-gallery-show-more').forEach(initGalleryShowMore);
})();
